module.exports = __webpack_public_path__ + "static/assets/2ab79ba84edfbe96e42aeef5611f4d83.png";